import { Box } from "@mui/material";
import styles from "./style.module.css";
import Apply from "./components/apply";
import Content01 from "./components/content01";
import Content02 from "./components/content02";

const Content = ({ projectUser, project, ageRanges, projectRoles }) => {
  return (
    <Box className={styles.content}>
      <Content01 projectUser={projectUser} project={project} />
      <Content02
        ageRanges={ageRanges}
        projectRoles={projectRoles}
        project={project}
      />
      <Apply project={project} />
    </Box>
  );
};

export default Content;
